export default __webpack_public_path__ + "static/media/964.78f9c8f3.gif";